import {
  Component,
  ViewChild,
  ElementRef,
  Input,
} from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { NotaControlCppcService } from 'src/app/modules/acbcr/common/services/nota-control-cppc.service'

@Component({
  selector: 'app-animale-nota-control-cppc',
  templateUrl: './animale-nota-control-cppc.component.html',
  styleUrls: ['./animale-nota-control-cppc.component.scss']
})
export class AnimaleNotaControlCppcComponent {
  @ViewChild('animaleNotaControlCPPCModal') animaleNotaControlCPPCModal: ElementRef;
  @Input() modalData = {};

  isAdmin = false;
  isOperator = false;
  modalReference: NgbModalRef;
  animalArrayForm = new UntypedFormArray([]);
  animalInfo = [];
  checkboxToateAnimalele = false;

  constructor(
    public modalService: NgbModal,
    private helperDataService: HelperDataService,
    private notaControlCppcService: NotaControlCppcService,
  ) { }

  ngOnInit() {
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
  }

  ngOnChanges(changes) {
    if (changes.modalData && this.modalData) {
      if (this.modalData['id']) {

        this.modalReference = this.modalService.open(this.animaleNotaControlCPPCModal, {
          windowClass: 'modal-half-full',
          scrollable: true,
        });

        this.notaControlCppcService.animaleAPI({ id: this.modalData['id'] })
          .subscribe({
            next: (response: Array<any>) => {
              this.animalInfo = response;
              this.buildForm();
            }
          })
      }
    }
  }

  buildForm() {
    this.animalArrayForm = new UntypedFormArray([]);

    if (!this.animalInfo['animale']) {
      return;
    }

    for (let animal of this.animalInfo['animale']) {
      let animalForm = new UntypedFormGroup({
        id: new UntypedFormControl(animal['id']),
        selectat: new UntypedFormControl(animal['selectat']),
      });

      this.animalArrayForm.push(animalForm);
    }
  }

  onSubmitted() {
    let req_params = {
      id: this.modalData['id'],
      animale: this.animalArrayForm.value,
    }

    this.notaControlCppcService.updateApreciereFenotipicaAPI(req_params)
      .subscribe({
        next: (response) => {
          this.modalReference.close();
        }
      })
  }

  downloadFile(event) {
    event.target.disabled = true;
    let fileId = this.animalInfo['file_id'];
    let fileName = this.animalInfo['file_name'];

    this.helperDataService.downloadFile(fileId)
      .subscribe({
        next: (response: any) => {
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fileName);
          event.target.disabled = false;
        }
      });
  }

  clickToateAnimalele(event) {
    this.checkboxToateAnimalele = event.target.checked;

    for (let animalForm of this.animalArrayForm.controls) {
      let animalFormGroup = animalForm as UntypedFormGroup;
      animalFormGroup.controls.selectat.setValue(this.checkboxToateAnimalele);
    }
  }

  clickCheckboxAnimal() {
    if (this.checkboxToateAnimalele) {
      this.checkboxToateAnimalele = false;
    }
  }

}
